/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  AfterViewInit,
  OnChanges,
  ChangeDetectionStrategy,
  SimpleChanges
} from '@angular/core';
import { DataTableHeader } from '../../../../data-table/DataTableHeader';
import { CustomItemContext } from 'app/components/data-table/data-table.component';
import { templateParseHandler } from 'app/utils';

export interface OverlapReport {
  label: string;
  icon: string;
  data: Array<any>;
  sortMap: any;
  showAll: boolean;
}

@Component({
  selector: 'app-user-overlap',
  templateUrl: './app-user-overlap.html',
  styleUrls: ['./app-user-overlap.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppUserOverlapComponent implements AfterViewInit, OnChanges {
  @Input() data;
  @Input() os: any;
  @Input() device: any;
  @Input() region: any;
  @Input() isFollowing: boolean;
  @Input() isFreemium: boolean;
  @Output() anchorClick = new EventEmitter<string>();
  @Output() followClick = new EventEmitter<boolean>();

  @ViewChild('titleTemplate') titleTemplate: TemplateRef<CustomItemContext>;

  headers: Array<DataTableHeader>;
  byOverallMaxValueMapping: any;
  byIvtMaxValueMapping: any;
  byOverallStats: Array<any>;
  byIvtStats: Array<any>;
  showMoreLimit = 10;

  ngAfterViewInit(): void {
    this.headers = [];
    this.headers.push({
      class: 'col-3',
      text: 'App',
      key: 'name',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col-3 text-xs-right',
      text: 'User Overlap',
      key: 'deviceOverlapRate',
      tooltipkey: '',
      format: 'percentbar'
    });
    this.headers.push({
      class: 'col-3 text-xs-right',
      text: 'Inventory Overlap',
      key: 'impOverlapRate',
      tooltipkey: '',
      format: 'percentbar'
    });
    this.headers.push({
      class: 'col-3 text-xs-right',
      text: 'Developer',
      key: 'publisherName',
      tooltipkey: ''
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.byOverallMaxValueMapping = {};
      this.byIvtMaxValueMapping = {};
      this.byOverallStats = [];
      if (this.isNotEmpty(this.data.overlapStats.byOverall)) {
        this.byOverallMaxValueMapping['impOverlapRate'] = 0;
        this.byOverallMaxValueMapping['deviceOverlapRate'] = 0;
        this.data.overlapStats.byOverall.forEach(overlapStat => {
          const stat = JSON.parse(
            JSON.stringify(overlapStat, templateParseHandler)
          );
          this.prepareOverlapStat(stat, this.byOverallMaxValueMapping);
          this.byOverallStats.push(stat);
        });
      }

      this.byIvtStats = [];
      if (this.isNotEmpty(this.data.overlapStats.byIvt)) {
        this.byIvtMaxValueMapping['impOverlapRate'] = 0;
        this.byIvtMaxValueMapping['deviceOverlapRate'] = 0;
        this.data.overlapStats.byIvt.forEach(overlapStat => {
          const stat = JSON.parse(
            JSON.stringify(overlapStat, templateParseHandler)
          );
          this.prepareOverlapStat(stat, this.byIvtMaxValueMapping);
          this.byIvtStats.push(stat);
        });
      }
    }
  }

  isNotEmpty(arr: Array<any>) {
    return arr && arr.length > 0;
  }

  prepareOverlapStat(overlapStat: any, maxValueMapping: any) {
    overlapStat.nameRouterLink = [
      '/insight',
      'apps',
      overlapStat.appId,
      this.region,
      this.os,
      this.device
    ];
    overlapStat.nameQueryParams = { section: '#app-overview' };
    overlapStat.nameTemplate = this.titleTemplate;

    if (maxValueMapping['impOverlapRate'] < overlapStat.impOverlapRate) {
      maxValueMapping['impOverlapRate'] = overlapStat.impOverlapRate;
    }
    if (maxValueMapping['deviceOverlapRate'] < overlapStat.deviceOverlapRate) {
      maxValueMapping['deviceOverlapRate'] = overlapStat.deviceOverlapRate;
    }
  }

  goToSection(section: string) {
    this.anchorClick.emit(section);
  }

  follow(): void {
    this.followClick.emit(true);
  }
}
